import { css } from 'styled-components';

import theme from 'styles/token/color';

export const getLayoutStyle = (layout) => {
  switch (layout) {
    case 'two-column-wrap':
      return css`
        display: flex;
        flex-wrap: nowrap;
        gap: 4px;
        width: max-content;

        background: ${theme.color.gray80};
        border-radius: 6px;
        padding: 4px;

        & > button {
          border-radius: 6px;
          border-color: transparent;
        }
      `;
    case 'vertical-column':
      return css`
        display: flex;
        align-items: normal;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 16px;
      `;
    default:
      return css``;
  }
};
